import React, { useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import MenuModal from './MenuModal';
import { Segment, Divider, Grid, GridColumn, Icon } from 'semantic-ui-react';

export function Menu() {
    const history = useHistory();

    const [modalOpen, setModalOpen] = useState(false);
    const closeModal = () => setModalOpen(false);
    const handleClick = () => setModalOpen(!modalOpen);
    const handleSubmit = (roomcode: number) => {
        //check room code
        // eslint-disable-next-line eqeqeq
        if (roomcode % 2 == 0) {
            console.log('Mehet a menet');
            console.log(roomcode * 2);
            closeModal();
            history.push(`/prepRoom?id=${roomcode}`);
        } else {
        }
    };
    return (
        <Segment secondary inverted raised>
            <Divider vertical>VAGY</Divider>
            <Grid columns='2' relaxed stackable>
                <GridColumn verticalAlign='middle'>
                    <NavLink
                        exact
                        to='/waitingRoom'
                        className='animated fade ui big fluid yellow button'
                    >
                        <div className='visible content'>
                            <Icon name="game"></Icon>
                        </div>
                        <div className='hidden content'>ÚJ JÁTÉK</div>
                    </NavLink>
                </GridColumn>
                <GridColumn verticalAlign='middle'>
                    <button
                        className='animated fade ui big fluid yellow button'
                        onClick={handleClick}
                    >
                        
                        <div className='visible content'>
                           <Icon name="globe"></Icon>
                        </div>
                        <div className='hidden content'>CSATLAKOZÁS</div>
                    </button>

                    {/* {showForm ? <RoomForm /> : null} */}
                    <MenuModal
                        modalOpen={modalOpen}
                        onClose={closeModal}
                        onSubmit={handleSubmit}
                    />
                </GridColumn>
            </Grid>
        </Segment>
    );
}
